var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeVisible = function SvgEyeVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.912 8.454C17.285 7.178 14.766 5.657 12 5.657c-2.754 0-5.28 1.54-6.913 2.832C3.472 9.767 2 11.426 2 11.97c0 .62 1.415 2.246 3.089 3.55 1.326 1.032 3.987 2.764 6.911 2.764 2.926 0 5.586-1.73 6.911-2.76 1.674-1.303 3.09-2.93 3.09-3.553-.001-.583-1.444-2.226-3.09-3.517M12 16.105a4.135 4.135 0 1 1 0-8.269 4.135 4.135 0 0 1 0 8.27"
  })));
};
export default SvgEyeVisible;